var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"EmptyView",class:[_vm.alignmentClass]},[_c('p',{staticClass:"font-weight-bold font-size-20 mb-0"},[_vm._v(_vm._s(_vm.title))]),_c('p',{},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }